'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var util = {

    /*
         * 以json对象的方式返回表单中的数据
         * @param {object}
         * @param.formId {string} 表单Id
         * @param.hasCheckbox {boolean} 是否包含多选框(直接对form表单序列化会checkbox获取值错误)
         * @param.checkboxName {string} 多选框名称
         * @param.isMethodGET  是否是GET  true 代表是GET  false代表是POST
         */
    getFormData: function getFormData(param, isMethodGET) {
        var dataArr = $('#' + param.formId).serialize().split("&");
        var dataObj = {};
        for (var i = 0, len = dataArr.length; i < len; i++) {
            var key = dataArr[i].split('=')[0];
            var value = dataArr[i].split('=')[1];
            //转义因为双引号
            //英文双引号为"%22"
            if (value) {
                value = value.replace(/%22/ig, "%5C%22"); // \"
                value = value.replace(/\+/g, ' '); //serialize会将空格转义为+
                value.trim(); //移除前后空格
            }

            dataObj[key] = value;
        }

        if (param.hasCheckbox) {
            dataObj[param.checkboxName] = [];

            var checkboxValArr = $("input[name='" + param.checkboxName + "']:checked").serialize().split("&");
            for (var i = 0, len = checkboxValArr.length; i < len; i++) {
                dataObj[param.checkboxName].push(checkboxValArr[i].split("=")[1]);
            }
        }
        if (!isMethodGET) {
            for (var item in dataObj) {
                dataObj[item] = decodeURIComponent(dataObj[item]);
            }
        }

        return dataObj;
    },
    getFormData_get: function getFormData_get(param) {

        return this.getFormData(param, true);
    },
    /**
     * 获取URL参数
     * @return {Object} {key:value}
     */
    getURLParams: function getURLParams() {
        function parseParams(str) {
            var rs = {};
            var i = str.indexOf('?');
            if (i >= 0) {
                str = str.substr(i + 1);
                var params = str.split('&');
                params.forEach(function (s) {
                    var p = s.split('=');
                    if (p.length >= 2) {
                        rs[p[0]] = p[1];
                    }
                });
            }
            return rs;
        }

        return _extends({}, parseParams(location.search), parseParams(location.hash));
    },


    // slog
    slog: function slog(eventName, params) {
        try {
            window.slog.dot(eventName, params);
        } catch (e) {
            console.error('slog script load fail.');
        }
    },

    /*
    *banner拉新抖动效果
    *@$panel 抖动元素
    *@attr 属性值 eg: right  left 等px属性
    */
    shake: function shake($panel, attr) {
        var box_attr = 24;
        for (var i = 1; 4 >= i; i++) {
            $panel.animate(_defineProperty({}, attr, box_attr - (20 - 5 * i)), 30);
            $panel.animate(_defineProperty({}, attr, box_attr + (20 - 5 * i)), 30);
        }
        return;
    }
};

exports["default"] = util;


//////////////////
// WEBPACK FOOTER
// ./src/js/common/util.js
// module id = 32
// module chunks = 0 4